import { createReducer, on } from '@ngrx/store';
import { loadUserTypesSuccess } from './userTypes.actions';
import { IDropDownList } from '@interfaces';

export interface UserTypesState {
  userTypes: IDropDownList[];
}

export const initialState: UserTypesState = {
  userTypes: [],
};

export const userTypesReducer = createReducer(
  initialState,
  on(loadUserTypesSuccess, (state, { userTypes }) => ({
    ...state,
    userTypes,
  })),
);

export function userTypeReducer(state: UserTypesState | undefined, action: any) {
  return userTypesReducer(state, action);
}
